import { GroupedErrorLog, ServerErrorLog } from "../CandyApiClient/Types/ErrorLog/ServerErrorLog";

import { DriveHelpers } from "./DriveHelpers";

export const ensureCandyFrontSrvDriveUri = async (driveUri: string, driveHelpers?: DriveHelpers): Promise<string> => {
    let driveUriChecked = driveUri;
    if (driveHelpers) {
        driveUriChecked = await driveHelpers.ensureCandyFrontSrv(driveUri);
    }
    return driveUriChecked;
};

export const ensureCandyFrontSrvDriveUris = async (
    driveUris: string[],
    driveHelpers?: DriveHelpers
): Promise<string[]> => {
    let driveUrisChecked = driveUris;
    if (driveHelpers) {
        driveUrisChecked = await Promise.all(driveUris.map(driveUri => driveHelpers?.ensureCandyFrontSrv(driveUri)));
    }
    return driveUrisChecked;
};

export const checkedErrorLog = async <ErrorLog extends ServerErrorLog | GroupedErrorLog>(
    errorLog: ErrorLog,
    driveHelpers?: DriveHelpers
): Promise<ErrorLog> => {
    const errorLogNameChecked = await ensureCandyFrontSrvDriveUri(errorLog.errorLogName ?? "", driveHelpers);
    const errorLogPropsChecked = await ensureCandyFrontSrvDriveUri(errorLog.propsName ?? "", driveHelpers);
    return {
        ...errorLog,
        errorLogName: errorLogNameChecked,
        propsName: errorLogPropsChecked,
    };
};
